export default __webpack_public_path__ + "static/media/ic_todos.7bbdfff3.svg";